import { createSelector } from 'reselect';
import numeral from 'numeral';

export const selectActiveCourse = createSelector(
  (courses, courseId) =>
    courses.get('data') ? courses.get('data').find(ep => ep.get('id') === parseInt(courseId, 10)) : null,
  course => (course ? course : null)
);

export const selectActiveChapter = createSelector(
  (chapters, chapterId) =>
    chapters.get('data') ? chapters.get('data').find(chapter => chapter.get('id') === parseInt(chapterId, 10)) : null,
  chapter => (chapter ? chapter : null)
);

export const selectChapters = createSelector(
  state => state.courses.chapters,
  chapters => (chapters.get('data') ? chapters.get('data').toJS() : null)
);

export const selectActiveLesson = createSelector(
  (lessons, lessonId) =>
    lessons.get('data') ? lessons.get('data').find(lesson => lesson.get('id') === parseInt(lessonId, 10)) : null,
  lesson => (lesson ? lesson : null)
);

export const selectLessons = createSelector(
  state => state.courses.lessons,
  lessons => (lessons.get('data') ? lessons.get('data').toJS() : null)
);

export const selectFormattedVideoSections = createSelector(
  lesson =>
    lesson
      .get('video_sections')
      .toJS()
      .map(section => {
        section.startTime = numeral(section.startTime).format('00:00:00');
        return section;
      }),
  sections => sections
);

export const selectVideoSections = createSelector(lesson => lesson.get('video_sections').toJS(), sections => sections);



// WEBPACK FOOTER //
// ./src/courses/selectors.js